var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-list"},[_c('div',{staticStyle:{"margin-bottom":"20px","color":"rgba(0,0,0,.85)","font-weight":"700","font-size":"16px","line-height":"1.5"},style:(this.headStyle)},[_vm._v(_vm._s(this.title))]),_vm._v(" "),_vm._t("content")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dd4c251","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfileList/ProfileList.vue
// module id = null
// module chunks = 